var render, staticRenderFns
import script from "./LeftTabbox.vue?vue&type=script&lang=js&"
export * from "./LeftTabbox.vue?vue&type=script&lang=js&"
import style0 from "./LeftTabbox.vue?vue&type=style&index=0&id=42b1eca4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1eca4",
  null
  
)

export default component.exports